export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `
        <p>
          Ежедневник недатированный размером 14.5x20.5x2 см. 
          Обложка из искусственной кожи.
        </p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `
        <h3>УФ-печать</h3>
        <p>
          Чернила закрепляются на любой поверхности (бумага, ткань, металл и т.д.) с помощью ультрафиолетового излучения, что значительно сокращает время обработки после печати и, соответственно, ускоряет сроки изготовления.
        </p>
      `
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
